import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueNotify from 'vue-notifyjs';
import VeeValidate from 'vee-validate';
import * as VueDeepSet from 'vue-deepset';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import App from './App.vue';
import Bus from './bus';

import debug from './debug';

// Plugins
import GlobalComponents from './gloablComponents';
import GlobalDirectives from './globalDirectives';
import SideBar from './components/UIComponents/SidebarPlugin';

// router setup
import routes from './routes/routes';

// library imports

import './assets/sass/paper-dashboard.scss';
import './assets/sass/demo.scss';
import 'es6-promise/auto';
import i18n from 'src/i18n';
import moment from 'moment';
import { get } from 'lodash';
import 'moment/locale/zh-hk';
import sidebarLinks from './sidebarLinks';
import auth from './auth';
import { apiHost, getCookie, parseResponse } from './utils';

// plugin setup
Vue.use(i18n);
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(VeeValidate, { fieldsBagName: '_fields' });
Vue.use(VueDeepSet);
Vue.use(Bus);
Vue.use(auth);
locale.use(lang);

Vue.http.options.root = apiHost() + 'api';
// parse api error
Vue.http.interceptors.push((req, next) => {
  if (req.method === 'POST') {
    next(parseResponse);
  } else {
    next();
  }
});

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(x => x.meta.auth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!get(store, 'state.auth.access_token')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      return;
    }
  }
  next(); // make sure to always call next()!
});

import * as Appointment from 'src/schemas/appointment';
import * as Notification from 'src/schemas/notification';

const store = new Vuex.Store({
  state: {
    local: 'en',
    notifications: [
      {
        title: '${i18n.schema.appointments} (waiting admin approve)',
        count: 0,
        link: '/admin/appointments',
      },
      {
        title: '${i18n.schema.appointments} (matching helper)',
        count: 0,
        link: '/admin/appointments',
      },
      {
        title: '${i18n.schema.notifications}',
        count: 0,
        link: '/admin/notifications',
      },
    ],
    auth: null,
  },
  mutations: {
    auth (state, v) {
      if (v != null) {
        window.localStorage.auth = JSON.stringify(v);
        window.localStorage.device_uuid = v.device_uuid;
      } else {
        window.localStorage.removeItem('auth');
      }
      state.auth = v;
      v = v || {};
      Vue.http.headers.common['device-uuid'] = v.device_uuid;
      Vue.http.headers.common['access-token'] = v.access_token;
      Vue.http.headers.common['device'] = 'Admin Panel on ' +
        get(navigator, 'platform', 'unknown');
    },
  },
  actions: {
    refreshNotifications (store) {
      if (store.state.auth && store.state.auth.access_token) {
        Vue.http.get('getAdminNotificationStats').then(response => {
          let data = response.body.data;
          store.state.notifications[0].count = data.waiting_admin_approve;
          store.state.notifications[1].count = data.matching_helper;
          store.state.notifications[2].count = data.notifications;
        });
      }
    },
  },
});

// initialize access_token
try {
  store.commit('auth',
    window.localStorage.auth ? JSON.parse(window.localStorage.auth) : null);

  Vue.http.post('', { 'endpoint': 'getMyProfile' }).then(res => {
    if (['admin', 'superadmin'].indexOf(get(res, 'body.data.role')) < 0) {
      throw new Error(); // catch
    }
  }).catch(err => {
    store.commit('auth', null);
  });
} catch (e) {
}

// refresh notifications
setInterval(function () {
  store.dispatch('refreshNotifications');
}, 300000);
store.dispatch('refreshNotifications');

// define reactive property
Object.defineProperty(i18n, 'local', {
  get () {
    return store.state.local;
  },
  set (v) {
    if (!this.lang[v]) {
      v = this.fallbackLocal;
    }
    store.state.local = v;
    moment.locale(this.s('local'));
    document.cookie = `local=${v}; path=/; expires=${moment().
      add(1, 'month').
      toDate().
      toUTCString()}`;
    document.title = this.fr('application_title');
  },
  enumerable: true,
  configurable: true,
});

i18n.local = getCookie('local');

/* eslint-disable no-new */
let $vm = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  bus: new Vue(),
  created () {
    this.$sidebar.options.vm = this;
  },
  mounted () {
    this.$sidebar.reload();
  },
  watch: {
    $auth (v) {
      if (this.$route.meta.auth) {
        if (!get(v, 'access_token')) {
          this.$router.push('/login');
        } else {
          this.$sidebar.reload();
        }
      }
    },
  },
});

// auto refresh panel if not reloaded for some time
window.pageLoadTime = moment();
if (debug.DEBUG) {
  setInterval(() => {
    if (confirm(`The web page has not be refreshed for ${moment.duration(
      moment() - window.pageLoadTime).
      humanize()}, there may be newly built versions.\nDo you want to refresh?`)) {
      window.location.reload(true);
    }
  }, 2 * 60 * 60 * 1000);
}



// WEBPACK FOOTER //
// ./src/main.js